import React, { ComponentProps } from "react";

import { Controller, Message, useFormContext } from "react-hook-form";

import Switch from "../Switch/Switch";

interface Props {
  name: string;
  disabled?: boolean;
  required?: Message | false;
  rules?: ComponentProps<typeof Controller>["rules"];
  className?: string;
}

export default function FormSwitchField(props: Props): JSX.Element {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      rules={{ required: props.required, ...props.rules }}
      render={({ field }) => (
        <Switch
          on={field.value || false}
          onClick={() => field.onChange(!field.value)}
          disabled={props.disabled}
          className={props.className}
        />
      )}
    />
  );
}
